import {
  createPlatformTestApi,
  type PlatformTestApi,
  type PlatformTestApiDeps,
} from '@/common/utils/platformTestApi'

export const PLATFORM_TEST_API_GLOBAL = '__workflowTest'

export function installPlatformTestApi(deps: PlatformTestApiDeps): PlatformTestApi {
  const api = createPlatformTestApi(deps)
  ;(window as unknown as Record<string, unknown>)[PLATFORM_TEST_API_GLOBAL] = api
  return api
}

export function uninstallPlatformTestApi(): void {
  delete (window as unknown as Record<string, unknown>)[PLATFORM_TEST_API_GLOBAL]
}
